export const FORNECEDOR = 'FORNECEDOR';
export const FORNECEDOR_START = 'FORNECEDOR_START';
export const FORNECEDOR_SUCCESS = 'FORNECEDOR_SUCCESS';
export const FORNECEDOR_ERROR = 'FORNECEDOR_ERROR';

export const FORNECEDORTOTAIS = 'FORNECEDORTOTAIS';
export const FORNECEDORTOTAIS_START = 'FORNECEDORTOTAIS_START';
export const FORNECEDORTOTAIS_SUCCESS = 'FORNECEDORTOTAIS_SUCCESS';
export const FORNECEDORTOTAIS_ERROR = 'FORNECEDORTOTAIS_ERROR';
